// Phase 24B — Sales Return report
import TransactionReportPage from "./TransactionReportPage";

export default function SalesReturnReport() {
  return (
    <TransactionReportPage
      slug="sales-return"
      testidPrefix="sales-return-report"
      title="Sales Return Report"
      subtitle="Retailer → Distributor return lines with reason, amount, kg (where applicable)."
      initialDaysBack={90}
      filterConfig={{ showUser: true, showDistributor: true }}
    />
  );
}
